<template>
  <b-alert variant="danger" dismissible fade :show="errors.length > 0" @dismissed="close()">
    <span>処理に失敗しました。</span>
    <ul v-for="(error, idx) in errors" :key="idx">
      <li>{{error}}</li>
    </ul>
  </b-alert>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
  props: ["errors"],
  methods: {
    close(){
      this.$emit('close');
    }
  }
})
</script>